// src/pages/NotFoundPage.js
import React from "react";
import { useTranslation } from "react-i18next";
import usePageMeta from "../hooks/usePageMeta";

function NotFoundPage() {
  const { t } = useTranslation();
  usePageMeta(t("meta.notFound.title"));

  return (
    <div>
      <h1>404 - Not Found</h1>
    </div>
  );
}

export default NotFoundPage;
